<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 14:03:01
 * @LastEditors: sunyan 1055697528@qq.com
 * @LastEditTime: 2024-04-15 16:33:17
 * @FilePath: \jsczt\src\views\home.vue
 * @Description:政府预决算公开
-->
<template>
  <div class="container" :style="{ zoom: scale }">
    <div class="content-wrapper">
      <top></top>
      <div class="current">
        当前位置：首页 > {{ cname }}
      </div>
      <div class="content">
        <div class="content_left">
          <leftTree :curnode="currNode" :cname="cname" @curdata="getCurdata"></leftTree>
        </div>
        <div class="content_right">
          <div class="right_tab">
            <div class="year">
              <myYear @change="getYear" :year="year" @dateRange="getDateRange"></myYear>
            </div>
            <div class="place" @click="dqDialog = true">
            <myRegions :value="curplace"></myRegions>
            </div>
            <div class="choose" @click="updateData">查询</div>
          </div>
          <div class="choice">
            <span style="margin-left: 20px;">
              已选择:
              <span style="margin-left: 15px;">年份:{{ showYear }}</span>
              <span style="margin-left: 15px;">地区:{{ choicePlace }}</span>
            </span>
          </div>
          <div class="judges" v-if="judge">
            未到公开时间
          </div>
          <div v-else>
            <normalList :year="year" :classinfoid="this.$route.query.classinfoid" :deptList="0" :list-data="listData" :place="choicePlace"></normalList>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="footer">
        <div class="footercont">
          主办：江苏省财政厅 备案序号：苏ICP备15009401号
          公安备案号：32010602010331 网站标识码：3200000098 江苏省财政厅版权所有
          <div class="jiucuo">
            <span id="_span_jiucuo">
              <img @click="Link('3200000003')" style="border:0;cursor: pointer;" src="../assets/jiucuonew.png">
            </span>
          </div>
          <div class="dzjg">
            <span id="_ideConac">
              <a href="https://bszs.conac.cn/sitename?method=show&amp;id=105DF988641221CBE053012819ACE317" target="_blank">
                <img id="imgConac" vspace="0" hspace="0" border="0" src="../assets/red.png"></a>
              </span>
            </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dqDialog"
      :append-to-body="true"
      class="my_dialog"
      style="background-color: none">
      <choiceDialog v-if="dialogVisible" @curtext="getcurText" @close="getClose" :opentype="openType"></choiceDialog>
    </el-dialog>
  </div>
</template>

<script>
import myYear from '../components/myYear.vue'
import myRegions from '../components/myRegions.vue'
import top from '../components/top.vue'
import normalList from '../components/normalList.vue'
import leftTree from '../components/leftTree.vue'
import choiceDialog from '../components/choiceDialog.vue'
import dayjs from 'dayjs'
export default {
  name: 'overview',
  components: {
    myYear,
    myRegions,
    top,
    normalList,
    leftTree,
    choiceDialog
  },
  data () {
    return {
      year: '',
      showYear: '',
      // 当前节点
      currNode: '',
      // 节点名称
      cname: '',
      dqDialog: false,
      dialogVisible: false,
      curplace: '',
      choicePlace: '',
      listData: [],
      areaCode: '',
      ysList: ['政府预算', '预算报告', '预算报表', '报表说明'],
      jsList: ['政府决算', '决算报告', '决算报表', '报表说明'],
      today: '',
      judge: false,
      storageData: {},
      hasRange: false,
      trueYear: '',
      jsClassinfoid: ['28', '31', '18', '19', '20'],
      openType: 'ys',
      scale: 1 // 初始缩放比例
    }
  },
  computed: {
    getWindowSize () {
      return {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  },
  watch: {
    dqDialog: {
      handler (val) {
        this.dialogVisible = val
      },
      deep: true,
      immediate: true
    },
    scale: {
      handler (val) {
        window.addEventListener('load', this.handleResize)
      },
      deep: true,
      immediate: true
    },
    '$route.name': {
      handler (val) {
        this.handleResize()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    window.addEventListener('load', this.handleResize)
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    Link (sitecode) {
    // 该站点需要纠错页面的url地址
      var url = "http://yjsgk.jsczt.cn/#/"
      // 跳转至纠错系统填写页面
      window.open('http://121.43.68.40/exposure/jiucuo.html?site_code=' + sitecode + '&url=' + encodeURIComponent(url))
    },
    handleResize () {
      var width = this.getWindowSize.width
      // 假设你设计稿的宽度是 1920px
      var designWidth = 1920
      var scale = width / designWidth
      this.scale = scale.toFixed(2)
    },
    getClose (data) {
      if (data) {
        this.dqDialog = false
      }
    },
    getDateRange (date) {
      if (date.split(',')[0]) {
        this.hasRange = true
        localStorage.setItem("rangeyear", date);
        // if (date.split(',')[0] < date.split(',')[1]) {
        //   localStorage.setItem('rangeyear', date.split(',')[1])
        // } else {
        //   localStorage.setItem('rangeyear', date.split(',')[0])
        // }
      }
    },
    // 当前左侧栏目
    getCurdata (item) {
      
      // 清除头部的栏目名
      localStorage.setItem('topcname', '')
      this.currNode = item.classinfoid.toString()
      this.cname = item.cname
      if (this.curplace === '') {
        this.curplace = this.storageData.place
        this.areaCode = this.storageData.code
      }
      this.year = this.showYear
      this.ysList.forEach(val => {
        if (item.cname === val) {
          this.getStartTime(1, 'ys')
        }
      })
      this.jsList.forEach(val => {
        if (item.cname === val) {
          if (this.year === this.trueYear.toString()) {
            this.choicePlace = ''
            this.bmvalue = ''
            this.dwvalue = ''
          }
          this.getStartTime(1, 'js')
        }
      })
      if (this.currNode === '13' || this.currNode === '14' || this.currNode === '21') {
        console.log(1)
      } else {
        this.getListdata()
      }
      if (this.jsClassinfoid.includes(this.currNode)) {
        this.openType = 'js'
      } else {
        this.openType = 'ys'
      }
      // 更新路径数据
      var classinfoid = this.currNode
      delete this.storageData.place
      this.$router.push({ name: 'overView2', query: { classinfoid, ...this.storageData } })
      this.addData(item.classinfoid)
      // this.$http.post('/yjsUbas/yjs/add', {
      //   browserVersion:navigator.appVersion,
      //     browserName: navigator.appName,
      //     browserLanguage:navigator.language,
      //     areaCode:this.$route.query.code,
      //     areaName:this.choicePlace,
      //     // deptCode:item.deptcode,
      //     // deptName:item.deptname,
      //     // unitCode:"",
      //     // unitName:"",
      //     areaYear:this.$route.query.year,
      //     sourceType:6,
      //     fileType:item.classinfoid,
      //     url:window.location.href
      //   }).then(res => {
      //     // if (res.data.code === 200) {
      //       // this.listData = res.data.data
      //     }
      //   )
    },
    // 当前选中年份
    getYear (data) {
      this.year = data
      this.curplace = ''
      this.areaCode = ''
      if (data !== '自定义') {
        localStorage.setItem('year', data)
        localStorage.setItem('rangeyear', '')
      }
    },
    // 当前选中地区
    getcurText (data) {
      this.curplace = data.chnldesc
      this.areaCode = data.code
      this.storageData.parentid = data.chnlid
      this.curplace = data.chnldesc
      if (data.close === false) {
        this.dqDialog = false
      }
    },
    updateData () {
      this.showYear = this.year
      this.storageData.year = this.showYear
      this.storageData.place = this.curplace
      this.storageData.code = this.areaCode
      this.choicePlace = this.curplace
      localStorage.setItem('key', JSON.stringify(this.storageData))
      // 更新路径数据
      var classinfoid = this.currNode
      delete this.storageData.place
      this.$router.push({ name: 'overView2', query: { classinfoid, ...this.storageData } })
      this.getListdata()
    },
    // 列表数据
    async getListdata () {
      console.log(this.year)
      this.listData = []
      localStorage.setItem('ISdwname',0)
      if (this.areaCode === '') {
        this.$message({
          message: '行政区不能为空',
          type: 'error'
        })
      } else {
        let listParams = {
          fileType: this.currNode,
          areaCode: this.areaCode,
          year: this.year,
        };
        if (this.year != "自定义") {
          listParams.year = this.year;
          await this.$http
            .post("/api/yjsgk/findDataByFileType", listParams, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.listData = res.data.data;
              }
            });
        } else {
          let Year = localStorage.getItem("rangeyear");
          listParams.year = Year;
          if (Year.split(",")[0] > Year.split(",")[1]) {
            this.$message({
              message: "开始时间不能大于结束时间",
              type: "error",
            });
          } else {
            await this.$http
              .post("/api/yjsgk/findDataByFileType", listParams, {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              })
              .then((res) => {
                if (res.data.code === 200) {
                  this.listData = res.data.data;
                }
              });
          }
        }
      }
    },
    // 决算\预算公开时间判断
    async getStartTime (datetype, opentype) {
      this.today = dayjs().format('YYYY-MM-DD')
      await this.$http.post('/api/opentime/getStartTime', {
        areaCode: this.areaCode,
        areaYear: this.showYear,
        dateType: datetype, // 类型（1-政府公开日期 2-部门公开日期 3-单位公开日期）
        openType: opentype // 公开类型（js-决算 ys-预算）
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        if (res.data.code === 200) {
          if (res.data.data) {
            if (this.today < res.data.data.startdate) {
              this.judge = true
            } else {
              this.judge = false
            }
          }
        }
      })
    },
    updateLocalStorageData () {
      this.storageData = JSON.parse(localStorage.getItem('key'))
      // 左侧名称
      if (this.storageData) {
        if (this.storageData.year && this.storageData.year === '自定义') {
          this.year = localStorage.getItem('rangeyear')
          this.showYear = this.year
        }
        this.cname = localStorage.getItem('topcname') ? localStorage.getItem('topcname') : this.storageData.cname
      }
      if (this.currNode === '15') {
        this.cname = '政府预算'
      } else if (this.currNode === '18') {
        this.cname = '政府决算'
      }
      if (this.cname === '政府预算') {
        this.getStartTime(1, 'ys')
      }
      if (this.cname === '政府决算') {
        this.getStartTime(1, 'js')
      }
      this.jsList.forEach(val => {
        if (this.cname === val) {
          if (this.year === this.trueYear.toString()) {
            this.choicePlace = ''
            this.bmvalue = ''
            this.dwvalue = ''
          }
        }
      })
      this.getListdata()
      this.addData(this.$route.query.classinfoid)
    },
    isIdExists (treeData, code) {
      // 遍历树形数据的每个节点
      for (let i = 0; i < treeData.length; i++) {
        const node = treeData[i]
        if (node.code === code) {
          this.curplace = node.chnldesc
          return true
        }
        if (node.child && node.child.length > 0) {
          const isExists = this.isIdExists(node.child, code)
          if (isExists) {
            return true
          }
        }
      }
      return false
    },
    getcurArea () {
      this.$http.get('/api/wcmchannel/findxzqh', {
        params: {
          year: this.year,
          openType: this.openType
        }
      }).then(res => {
        if (this.$route.query.code === res.data.data.code) {
          this.curplace = res.data.data.chnldesc
        } else {
          this.isIdExists(res.data.data.child, this.$route.query.code)
        }
        this.choicePlace = this.curplace
        var datas = {
          place: this.curplace,
          code: this.areaCode,
          year: this.year,
          parentid: this.$route.query.parentid
        }
        // 存储路径上的值
        localStorage.setItem('key', JSON.stringify(datas))
        this.updateLocalStorageData()
      })
    }
  },
  created () {
    let date = new Date() // 获取当前时间
    this.trueYear = date.getFullYear() // 获取当前年份
    this.year = this.$route.query.year
    this.currNode = this.$route.query.classinfoid
    if (this.jsClassinfoid.includes(this.currNode)) {
      this.openType = 'js'
    } else {
      this.openType = 'ys'
    }
    this.areaCode = this.$route.query.code
    this.showYear = this.year
    this.getcurArea()
  }
}
</script>
<style scoped>
@import url('../assets/overview.css');
</style>



// WEBPACK FOOTER //
// src/views/overview2.vue